import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import React from 'react';
import CmsContent from '../../../CmsContent';
import useBrand from '../../../../hooks/use-brand';
import { getClasses } from '../../../../../lib/style-utils/style-utils';
import navigation from '../../../../../lib/navigation/navigation';
import styles from '../SplashCta.less';

function handleNavigation(splashNavigationUrl) {
  return navigation({
    navigationUrl: splashNavigationUrl,
    displayType: 'saml'
  });
}

function SplashLink(_ref) {
  var title = _ref.title,
      _ref$splashUrl = _ref.splashUrl,
      splashUrl = _ref$splashUrl === void 0 ? {} : _ref$splashUrl,
      primary = _ref.primary;
  var brand = useBrand();
  var splashNavigationUrl = splashUrl && (splashUrl.Description || splashUrl.description);
  return /*#__PURE__*/React.createElement("button", {
    role: "link",
    tabIndex: 0,
    "data-primary-button": primary,
    onClick: function onClick() {
      handleNavigation(splashNavigationUrl);
    },
    onKeyDown: function onKeyDown(event) {
      if (event.which === 13 || event.keyCode === 13) {
        handleNavigation(splashNavigationUrl);
      }
    },
    "data-url": splashNavigationUrl,
    className: getClasses({
      styles: styles,
      classes: [primary ? 'btnPrimary' : 'btnSecondary'],
      brand: brand
    })
  }, /*#__PURE__*/React.createElement(CmsContent, {
    content: title
  }));
}

export default SplashLink;